import React from "react";
import { CgMail } from 'react-icons/cg'
import { AiOutlineTwitter } from 'react-icons/ai'

function Contact() {
    return (
        <section id='contact' className='page6'>

            <div className='links'>
                <div className="icons">
                    <button className="twitter-icon"><a className="a-twitter" href="https://twitter.com/ArmadillosN" target="_blank"><AiOutlineTwitter /></a> </button>
                    <a className="a-opensea" href="https://opensea.io/collection/armadillosnft-collection" target="_blank"><img className="opensea-icon" src="././images/opensea.png" /></a>
                    <button className="mail-icon"><a className="a-mail" href={`mailto:armadillosnftseries@gmail.com`} target="_blank"><CgMail /></a></button>
                </div>
                <div>
                    <h4 className="made">@2022 Armadillos NFT</h4>
                </div>
            </div>
        </section >
    )
}

export default Contact

